export type AvailabilityRange = { startMinute: number; endMinute: number };
export type WeekSchedule = Record<number, AvailabilityRange[]>;

// Per-day validation: order within each range + no overlaps (touching edges OK).
// Lives outside the editor component so it can be unit-tested directly (Radix
// Selects are impractical to drive in jsdom).
export function validateWeek(week: Partial<WeekSchedule>): Record<number, string> {
  const errors: Record<number, string> = {};
  for (const [weekdayStr, dayRanges] of Object.entries(week)) {
    const weekday = Number(weekdayStr);
    const ranges = [...(dayRanges ?? [])].sort((a, b) => a.startMinute - b.startMinute);
    for (const r of ranges) {
      if (r.startMinute >= r.endMinute) {
        errors[weekday] = "La hora de inicio debe ser antes de la de fin.";
      }
    }
    for (let i = 1; i < ranges.length; i++) {
      if (ranges[i]!.startMinute < ranges[i - 1]!.endMinute) {
        errors[weekday] = "Hay horarios que se traslapan.";
      }
    }
  }
  return errors;
}
